import e from "react";
import { NoMatchingLocationsStep as o } from "./steps/NoMatchingLocationsStep.js";
import { SelectionStep as n } from "./steps/SelectionStep.js";
import { ConfirmationStep as r } from "./steps/ConfirmationStep.js";
import { SuccessStep as m } from "./steps/SuccessStep.js";
import { useBooking as a } from "./context.js";
import { ReservationStep as i } from "./steps/ReservationStep.js";
import c from "./bookingForm.module.scss.js";
function g() {
  const {
    currentStep: t
  } = a();
  return /* @__PURE__ */ e.createElement("div", { "data-testid": "booking-form", className: c.form }, t.name === "reservation" && /* @__PURE__ */ e.createElement(i, null), t.name === "noMatch" && /* @__PURE__ */ e.createElement(o, null), t.name === "selection" && /* @__PURE__ */ e.createElement(n, null), t.name === "confirmation" && /* @__PURE__ */ e.createElement(r, null), t.name === "success" && /* @__PURE__ */ e.createElement(m, null));
}
export {
  g as BookingForm
};
//# sourceMappingURL=BookingForm.js.map
